import { createRouter, createWebHistory } from "vue-router";
import routes from "@/router/routes";
import { useUserStore } from "@/store/user";
import { storeToRefs } from "pinia";

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0 };
    }
  },
});

router.beforeEach(async (to) => {
  const userStore = useUserStore();
  const { isAdmin, isDistributionManager, userRole, accessToken } =
    storeToRefs(userStore);
  if (to.matched.some((r) => r.meta?.notAuthorized)) {
    return accessToken.value ? { path: "/orders" } : true;
  }

  if (to.matched.some((r) => r.meta?.protected) && !accessToken.value) {
    return { path: "/login", query: { redirect: to.fullPath } };
  }

  if (to.matched.some((r) => r.meta?.admin)) {
    return isAdmin.value ? true : { path: "/orders" };
  }

  const recWithRoles = to.matched.find((r) =>
    Array.isArray(r.meta?.allowedRoles)
  );
  if (recWithRoles) {
    const allowedRoles = recWithRoles.meta?.allowedRoles as string[];
    const ok = userRole.value && allowedRoles.includes(userRole.value);
    if (!ok) {
      return isDistributionManager.value
        ? { path: "/distributions" }
        : { path: "/orders" };
    }
  }

  if (
    isDistributionManager.value &&
    !["/distributions", "/login"].includes(to.path)
  ) {
    return { path: "/distributions" };
  }

  return true;
});

export default router;
